import BaseMystery from '../BaseMystery'

const FirstLuminousMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/b/bacchiac/baptism1.jpg",
		"https://www.wga.hu/art/b/bacchiac/baptism2.jpg",
		"https://www.wga.hu/art/b/bacchiac/baptism.jpg",
		"https://www.wga.hu/art/a/algardi/4/baptism.jpg",
		"https://www.wga.hu/art/b/bartolom/giovanni/predell6.jpg",
		"https://www.wga.hu/art/b/bellini/giovanni/1500-09/167bapti.jpg",
		"https://www.wga.hu/art/b/borzone/baptism.jpg",
		"https://www.wga.hu/art/c/carracci/annibale/1/baptism.jpg",
		"https://www.wga.hu/art/c/cima/1/02baptis.jpg",
		"https://www.wga.hu/art/f/francken/frans2/baptism.jpg",
		"https://www.wga.hu/art/g/ghirland/domenico/1early/3brozzi2.jpg",
		"https://www.wga.hu/art/g/ghirland/domenico/6tornab/62tornab/6baptis.jpg",
		"https://www.wga.hu/art/g/giotto/padova/old/chris07.jpg",
		"https://www.wga.hu/art/g/giusto/padua/4south1.jpg",
		"https://www.wga.hu/art/g/grebber/pieter/baptism.jpg",
		"https://www.wga.hu/art/g/greco_el/02/0203grec.jpg",
		"https://www.wga.hu/art/g/greco_el/22/2201grec.jpg",
		"https://www.wga.hu/art/g/greco_el/11/1108grec.jpg",
		"https://www.wga.hu/art/j/juan/1/baptism.jpg",
		"https://www.wga.hu/art/l/lemoyne/jeanbapt/baptism.jpg",
		"https://www.wga.hu/art/m/mantegna/11/4funera1.jpg",
		"https://www.wga.hu/art/m/masolino/olona/06olona.jpg",
		"https://www.wga.hu/art/m/master/frankfur/triptyc2.jpg",
		"https://www.wga.hu/art/m/master/bartholo/baptism.jpg",
		"https://www.wga.hu/art/m/mildorfe/mildorf3.jpg",
		"https://www.wga.hu/art/m/murillo/1/115muril.jpg",
		"https://www.wga.hu/art/n/navarret/baptism.jpg",
		"https://www.wga.hu/art/p/palmezza/baptism.jpg",
		"https://www.wga.hu/art/p/patenier/baptism.jpg",
		"https://www.wga.hu/art/p/preti/baptism1.jpg",
		"https://www.wga.hu/art/r/reni/1/baptism.jpg",
		"https://www.wga.hu/art/r/rosi/baptism.jpg",
		"https://www.wga.hu/art/t/tintoret/1_1540s/7baptism.jpg",
		"https://www.wga.hu/art/t/tintoret/3b/2upper/2/23bapti.jpg",
		"https://www.wga.hu/art/v/veronese/03_1560s/2baptism.jpg",
		"https://www.wga.hu/art/v/verocchi/painting/baptism.jpg",
	];

	const scriptureQuote = "After Jesus was baptized, he came up from the water and behold, the heavens were opened [for him], and he saw the Spirit of God descending like a dove [and] coming upon him.";
	const scriptureCitation = "Matthew 3:16 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Matthew%203%3A1-17&version=NABRE";

	return (
		<BaseMystery titleText="The Baptism in the Jordan"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default FirstLuminousMystery;